import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c287e90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container w-100" }
const _hoisted_2 = ["value", "placeholder", "readonly"]
const _hoisted_3 = {
  key: 1,
  class: "text-red"
}

import { requiredRule } from "@/utils/rules";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
  modelValue: String,
  label: { type: String, default: "" },
  icon: String,
  rules: null,
  required: Boolean,
  dateValidation: Boolean,
  placeholder: String || undefined,
  readonly: Boolean || undefined,
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    if (props.dateValidation) {
      emit("update:modelValue", "");
    } else {
      emit("update:modelValue", value);
    }
  },
});

const rules = computed(() =>
  props.required ? [...(props.rules || []), requiredRule] : props.rules
);

const handleInput = (newValue: any) => {
  if (props.dateValidation && newValue) {
    emit("update:modelValue", "");
  } else {
    emit("update:modelValue", newValue);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createBlock(_component_v_input, {
    "model-value": value.value,
    rules: rules.value
  }, {
    default: _withCtx(({ isValid }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          type: "text",
          value: value.value,
          class: _normalizeClass(`w-100 px-2 bg-gray pb-1 pt-4 ${
            isValid.value === false ? 'error' : ''
          }`),
          placeholder: __props.placeholder,
          required: "",
          readonly: __props.readonly,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput(($event?.target as HTMLInputElement)?.value)))
        }, null, 42, _hoisted_2),
        _createElementVNode("label", null, [
          (__props.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "24",
                class: _normalizeClass(`icon mdi ${__props.icon}`)
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    message: _withCtx(({ message }) => [
      _createVNode(_component_v_icon, {
        size: "12",
        class: "mdi mdi-alert-circle-outline"
      }),
      _createTextVNode(" " + _toDisplayString(message), 1)
    ]),
    _: 1
  }, 8, ["model-value", "rules"]))
}
}

})